module.exports = __webpack_public_path__ + "static/media/DSC_0237.e47f5add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0237.jpg
// module id = 696
// module chunks = 0